import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

const INDEXED_KEY = ['indexed-expenses'];

function invalidateAll(qc) {
  qc.invalidateQueries({ queryKey: INDEXED_KEY });
  qc.invalidateQueries({ queryKey: ['forecasts'] });
  qc.invalidateQueries({ queryKey: ['cash-flow'] });
}

/**
 * Query — liste les dépenses indexées.
 * @param {Object} opts
 * @param {string} [opts.status='active'] — 'active' | 'archived'
 */
export function useIndexedExpenses({ status = 'active' } = {}) {
  return useQuery({
    queryKey: [...INDEXED_KEY, { status }],
    queryFn: () => api.get(`/indexed-expenses?status=${status}`),
    staleTime: 30_000,
  });
}

/**
 * Mutation — POST /indexed-expenses
 * body : { name, category_id, pct_of_revenue, start_date, end_date?, vat_rate?, notes? }
 */
export function useCreateIndexedExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post('/indexed-expenses', body),
    onSuccess: () => invalidateAll(qc),
  });
}

/**
 * Mutation — PATCH /indexed-expenses/:id
 * body : patch partiel
 */
export function useUpdateIndexedExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...patch }) => api.patch(`/indexed-expenses/${id}`, patch),
    onSuccess: () => invalidateAll(qc),
  });
}

/**
 * Mutation — DELETE /indexed-expenses/:id (soft → archived)
 */
export function useDeleteIndexedExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/indexed-expenses/${id}`),
    onSuccess: () => invalidateAll(qc),
  });
}
